import React, { useState } from "react";
import { IosDevelopersFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const IosDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Hire dedicated iOS developers in India to build high-performance, secure, and user-friendly mobile apps. Get expert iOS development tailored to your business goals."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Hire Dedicated iOS Developers in India | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/hire-ios-developers"
        />
        <meta
          property="og:description"
          content="Hire dedicated iOS developers in India to build high-performance, secure, and user-friendly mobile apps. Get expert iOS development tailored to your business goals."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Hire Dedicated iOS Developers in India | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Hire dedicated iOS developers in India to build high-performance, secure, and user-friendly mobile apps. Get expert iOS development tailored to your business goals."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/hire-ios-developers"
        />
        <title>
          Hire Dedicated iOS Developers in India | Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center p-6">
        <div className=" p-4 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10">
            <div className="lg:w-3/4  lg:text-left ">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Hire Dedicated iOS Developers in India
              </h1>
              <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
                iOS development is a cornerstone for businesses looking to
                create secure, high-quality apps for Apple's ecosystem. At
                Ayanshtech, we offer dedicated iOS developers proficient in
                Swift, Objective-C, and the latest iOS frameworks. Our team
                ensures your app delivers seamless performance, enhanced user
                experience, and adheres to Apple’s stringent guidelines.
                <br />
                <br />
                Whether you need a new app, updates to an existing app, or
                custom integrations, our iOS developers have the expertise to
                bring your vision to life. Hire iOS developers from Ayanshtech
                to create feature-rich, secure, and scalable mobile applications
                that elevate your business in the competitive iOS market.
              </p>
              <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
                Starting from just{" "}
                <span className="font-bold">US $18/hour</span>
              </p>
              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
              >
                Hire a iOS Developer
              </button>
            </div>
            <div className="flex justify-center mt-5 mb-10">
              <img
                src="\assets\images\headerSection\hireiOSDev\img1.png"
                alt="iOS App Development"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Expertise of Our iOS Developers
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Ayanshtech stands out as a trusted name in iOS development. Hire our
            skilled iOS developers to create fully optimized and feature-rich
            applications tailored to your needs.
          </p>
        </div>

        <div className=" p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Custom iOS App Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">App Planning and Consultation</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">iOS App QA and Testing</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">iOS App Designing</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Industry-Specific App Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">App Maintenance and Support</p>
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Partner with Expert iOS Developers
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            At Ayanshtech, our iOS specialists craft cutting-edge applications
            for iPhones, iPads, and wearable devices. Leveraging the latest iOS
            SDKs, XCode IDE, and UI frameworks, we deliver innovative solutions
            tailored to your business needs.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\headerSection\hireiOSDev\img2.png"
                alt="Graph on Laptop"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
            <div className=" md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon17.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    From startups to global enterprises, our team has
                    successfully built and launched diverse iOS applications.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon18.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Our developers stay ahead by continuously learning the
                    latest tools, technologies, and market trends.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon19.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Our experts bring extensive experience in crafting iOS
                    solutions for a variety of industries and business needs.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon20.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Stay informed! Our team ensures you're updated with every
                    new development in your project.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AyanshtechAdvantage />

        <div className="max-w-3xl mx-auto p-4 mt-10 w-full ">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {IosDevelopersFaqs.map((faq, index) => (
            <div key={index} className="border-b-2 border-blue-300">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  activeIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {activeIndex === index ? "-" : "+"}
                </span>
              </button>
              {activeIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <Contact />
        </div>
        <GetInTouch />
      </div>
    </>
  );
};

export default IosDevelopers;
